var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.975 20C8.40833 19.8 7.00834 19.4 5.775 18.8C4.54167 18.2 3.496 17.4167 2.638 16.45C1.78 15.4833 1.12567 14.3627 0.675001 13.088C0.224335 11.8133 -0.00066519 10.4007 1.47711e-06 8.85C1.83333 9.03333 3.38333 9.36667 4.65 9.85C5.91667 10.3333 6.946 11.0167 7.738 11.9C8.53 12.7833 9.10067 13.8877 9.45 15.213C9.79934 16.5383 9.97433 18.134 9.975 20ZM9.975 11.575C9.59167 10.9917 9.071 10.4167 8.413 9.85C7.755 9.28333 6.99233 8.76667 6.125 8.3C6.225 7.6 6.39167 6.875 6.625 6.125C6.85833 5.375 7.14167 4.63767 7.475 3.913C7.80833 3.18833 8.18767 2.49233 8.613 1.825C9.03833 1.15767 9.49233 0.549333 9.975 0C10.4583 0.55 10.9127 1.15833 11.338 1.825C11.7633 2.49167 12.1423 3.18767 12.475 3.913C12.8077 4.63833 13.091 5.37567 13.325 6.125C13.559 6.87433 13.7257 7.59933 13.825 8.3C12.9583 8.75 12.196 9.25833 11.538 9.825C10.88 10.3917 10.359 10.975 9.975 11.575ZM11.975 19.6C11.9417 18.4333 11.8543 17.354 11.713 16.362C11.5717 15.37 11.3507 14.4327 11.05 13.55C11.8333 12.2 12.9127 11.1 14.288 10.25C15.6633 9.4 17.5507 8.93333 19.95 8.85C19.9667 11.4833 19.2623 13.7543 17.837 15.663C16.4117 17.5717 14.4577 18.884 11.975 19.6Z",
    fill: "#91B0D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaIcon);
export default __webpack_public_path__ + "static/media/spa-icon.3a97948a5a47e5fa0b90a64e7ca10fb9.svg";
export { ForwardRef as ReactComponent };